import React from 'react';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid'; // Fixes issue with table overflow.
import { Divider } from '@mui/material';
import { Title } from 'shared/components/abstract/interactables';
import AssigneeTicketTable from 'shared/components/AssigneeTicketTable';
import profilePath from 'shared/routes/home';

export default function WelcomePage() {
  return (
    <Grid container spacing={1}>
      <Title title="Welcome to the Reactor!" />
      <Link to={profilePath}>My Profile</Link>
      <Grid size={12}>
        <Divider />
      </Grid>
      <Grid size={12}>
        <AssigneeTicketTable />
      </Grid>
    </Grid>
  );
}
